import { useSyncExternalStore } from 'react'

/**
 * One hook for every JavaScript-driven animation (the splash settle, skeletons, digit
 * crossfades). True when the OS asks for reduced motion or the device toggle "Kurangi
 * gerakan" set `html[data-motion="reduced"]` (index.html applies both before React mounts;
 * Pengaturan flips the attribute at runtime).
 */
export function isMotionReduced(): boolean {
  if (typeof document === 'undefined') return false
  if (document.documentElement.dataset.motion === 'reduced') return true
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches
}

function subscribe(onChange: () => void): () => void {
  const media = matchMedia('(prefers-reduced-motion: reduce)')
  media.addEventListener('change', onChange)
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-motion'] })
  return () => {
    media.removeEventListener('change', onChange)
    observer.disconnect()
  }
}

export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, isMotionReduced, () => false)
}
